import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag, PoundSterling, TrendingUp, Users, Clock, CheckCircle2, Bell } from "lucide-react";
import api, { money } from "@/lib/api";

const Card = ({ Icon, label, value, tint }) => (
  <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
    <div className={`rounded-xl p-2.5 w-fit ${tint}`}><Icon size={20} /></div>
    <p className="text-sm text-muted-foreground mt-3">{label}</p>
    <p className="font-heading font-extrabold text-2xl md:text-3xl">{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  const load = () => api.get("/admin/dashboard").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  if (!d) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-heading font-extrabold text-3xl">Dashboard</h1>
          <p className="text-sm text-muted-foreground">Today's performance at a glance.</p>
        </div>
        {d.pending_orders > 0 && (
          <button onClick={() => navigate("/admin/orders")} data-testid="pending-alert" className="flex items-center gap-2 bg-metros-red text-white rounded-full px-4 py-2.5 text-sm font-bold animate-pulse">
            <Bell size={16} /> {d.pending_orders} pending orders
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Card Icon={ShoppingBag} label="Orders today" value={d.orders_today} tint="bg-blue-100 text-blue-700" />
        <Card Icon={PoundSterling} label="Revenue today" value={money(d.revenue_today)} tint="bg-green-100 text-green-700" />
        <Card Icon={TrendingUp} label="Avg order value" value={money(d.avg_order_value)} tint="bg-amber-100 text-amber-700" />
        <Card Icon={Users} label="New customers" value={d.new_customers_today} tint="bg-purple-100 text-purple-700" />
        <Card Icon={Clock} label="Pending orders" value={d.pending_orders} tint="bg-red-100 text-red-700" />
        <Card Icon={CheckCircle2} label="Completed orders" value={d.completed_orders} tint="bg-green-100 text-green-700" />
      </div>

      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-heading font-bold text-lg">Recent orders</h2>
          <button onClick={() => navigate("/admin/orders")} className="text-sm font-semibold text-metros-red">View all</button>
        </div>
        {d.recent_orders.length === 0 ? <p className="text-sm text-muted-foreground py-8 text-center">No orders yet.</p> : (
          <div className="divide-y divide-gray-50">
            {d.recent_orders.map((o) => (
              <div key={o.id} className="flex items-center justify-between py-3 cursor-pointer" onClick={() => navigate("/admin/orders")}>
                <div><p className="font-semibold text-sm">{o.order_number}</p><p className="text-xs text-muted-foreground">{o.customer?.name} · {o.type}</p></div>
                <div className="text-right"><p className="font-bold text-sm">{money(o.total)}</p><p className="text-xs text-metros-red">{o.status.replace(/_/g, " ")}</p><p className={`text-[10px] font-bold ${(o.payment_status || (o.payment_method === "card" ? "pending" : "cash")) === "paid" ? "text-green-600" : (o.payment_status === "pending" ? "text-amber-600" : "text-gray-400")}`}>{(o.payment_status || (o.payment_method === "card" ? "pending" : "cash")) === "paid" ? "Paid" : o.payment_status === "pending" ? "Unpaid" : "Cash"}</p></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
